import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import CanDeleteAllFormsInSelection from 'common/Forms/Helpers/DeleteFormsHelper';

const ActionSelectDelete = ({ selectedItems, permissions, openDeleteFormModal }) => (
  <div className="action-select">
    <div className="panel-title-selected">
      <div className="dropdown dropdown-right">
        <button
          type="button"
          className="btn btn-link dropdown-toggle"
          id="btn-action-select-delete"
        >
          { selectedItems.length } items selected
          <span className="icon icon-caret" />
        </button>
        <ul className="menu">
          {CanDeleteAllFormsInSelection(selectedItems, permissions)
            && <li className="menu-item">
              <button
                type="button"
                className="btn btn-link"
                disabled={ selectedItems.length <= 0 }
                id="btn-action-select-bulk-delete"
                onClick={ () => openDeleteFormModal() }
              >
                Delete all
              </button>
            </li> }
        </ul>
      </div>
    </div>
  </div>
);

ActionSelectDelete.propTypes = {
  selectedItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  openDeleteFormModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  permissions: state.auth.permissions
});
export const ConnectedActionSelectDelete = connect(mapStateToProps)(ActionSelectDelete);

export default ConnectedActionSelectDelete;
